export default __webpack_public_path__ + "static/media/josera-redes.a6b386de.jpg";